__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "pudding";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@carbonx/chocolate-milk", "1.0.2", () => (() => (__webpack_require__(4706))), 1);
			register("@carbonx/milkshake/frontend", "3.0.3", () => (() => (__webpack_require__(1428))), 1);
			register("@carbonx/milkshake/tolgee", "3.0.3", () => (() => (__webpack_require__(632))), 1);
			register("@chakra-ui/react", "2.10.9", () => (() => (__webpack_require__(1486))), 1);
			register("@emotion/react", "11.14.0", () => (() => (__webpack_require__(5587))), 1);
			register("@emotion/styled", "11.14.1", () => (() => (__webpack_require__(3296))), 1);
			register("@tolgee/react", "6.6.0", () => (() => (__webpack_require__(777))), 1);
			register("framer-motion", "10.18.0", () => (() => (__webpack_require__(5559))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(961))), 1);
			register("react-router-dom", "6.30.1", () => (() => (__webpack_require__(2648))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(6540))), 1);
			initExternal(9827);
			initExternal(9175);
			initExternal(4203);
			initExternal(6763);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};